import styled from 'styled-components'
import { theme } from '../../styles/theme';

export const Container = styled.div`
    width: 100%;
    height: auto;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    padding: 0 1.5rem;

    gap: 48px;
    display: flex;
    align-items: center;
    flex-direction: column;

    background-color: ${theme.colors.gray.Cinza_1};

    @media (max-width: 768px) {
        overflow: auto;
        
        padding: 0 1.5rem 5rem;
    }
`;

export const Description = styled.div` 
    width: auto;
    height: auto;
    max-width: 20.4375rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: auto;
        height: 1.5rem;

        margin-top: 5rem;
        margin-bottom: 3rem;
    }

    >h3, >p{
        text-align: center;
    }
`;

export const NoCreditCard = styled.div` 
    width: auto;
    height: auto;
    padding: 0.3125rem 0.3125rem 0.3125rem 0.5rem;

    gap: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;
    background-color: #292E38;
`;

export const Form = styled.div` 
    width: 100%;
    height: auto;
    max-width: 26.25rem;
    padding: 2rem 1.5rem 1.5rem 1.5rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    border-radius: 0.5rem;

    background-color: #FFFFFF;

    @media (max-width: 365px) {
        padding: 1.5rem 1rem 1.5rem 1rem;
    }

    @media (max-width: 320px) {
        padding: 1.5rem 1rem 1.5rem 1rem;
    }
`;

export const ContainerInputs = styled.div` 
    width: 100%;
    height: auto;

    gap: 1rem; 
    display: flex;
    flex-direction: column;
`;

export const ContainerButtons = styled.div` 
    width: 100%;
    height: auto;

    gap: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    >a{
        width: 100%;
        height: auto;
        max-width: 6.688rem;
    }
`

export const ButtonLogin = styled.button` 
    all: unset;

    width: 100%;
    height: 3rem; 

    >p{
        text-align: center;
    }
`;


export const FormButton = styled.button`
    all: unset;

    height: 1.5rem;
    width: 6.3125rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    border-radius: 10rem;
    background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : `${theme.colors.green.Verde_AgroReceita}`)}; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

        color: ${({ disabled }) => (disabled ? '#AAAAAA' : '#FFFFFF')};
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;

        transition: filter 0.3s ease;
        filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')}; 
    }

    &:hover {
        background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : '#259D57')};
    }

    @media (max-width: 335px) {
        height: 1.2rem;
        width: 4.0125rem;

        >p{
            font-size: 0.5525rem;
            line-height: 0.9375rem;
        }

        >img{
            height: auto;
            width: 1.15rem;
        }
    }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: ${props => (props.disabled ? '1px solid #999' : props.outline ? props.red === true ? '1px solid #F10' : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-bottom: ${props => (props.disabled ? '1px solid #999' : props.outline ? props.red === true ? '1px solid #F10' : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;